import { render, staticRenderFns } from "./PagamentoModal.vue?vue&type=template&id=1d9baa9a"
import script from "./PagamentoModal.vue?vue&type=script&lang=js"
export * from "./PagamentoModal.vue?vue&type=script&lang=js"
import style0 from "./PagamentoModal.vue?vue&type=style&index=0&id=1d9baa9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports